var global = require('../internals/global');
var defineGlobalProperty = require('../internals/define-global-property');

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;



//////////////////
// WEBPACK FOOTER
// /Users/jordan/www/sites/chryso/wwwroot/wp-content/themes/chryso-v2/node_modules/core-js/internals/shared-store.js
// module id = 69
// module chunks = 0